import Typography from 'antd/es/typography';
import React from 'react';

import type { PDFReaderBlockConfig, PipelineBlock } from '@mai/types';

const { Text } = Typography;

interface PDFReaderBlockEditorProps {
  block: PipelineBlock & { type: 'pdf_reader' };
  onConfigChange: (config: PDFReaderBlockConfig) => void;
}

export const PDFReaderBlockEditor: React.FC<PDFReaderBlockEditorProps> = () => {
  return (
    <div>
      <Text type="secondary">
        This block converts PDF file streams to markdown text. No configuration
        is required.
      </Text>
    </div>
  );
};
